import {SET_BACKGROUND_MUSIC} from "@actions/actionTypes"

export default function backgroundMusicReducer(state = false, action) {
    switch (action.type) {
        case SET_BACKGROUND_MUSIC:
            return  action.payload
        default:
            return state;
    }
}